goog.require('el8.app.setup');
goog.require('el8.data.practiceUsers');

var el8 = el8 || {};
if(!el8.main) { el8.main = {}; }
el8.main.appbigUserUpload = {};

el8.main.appbigUserUpload.init = function(spec) {

    spec['layout'] = {innerContainerSelector: '.el8One'};
    el8.app.setup(spec);

    el8.data.practiceUsers.load();

};

